import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

interface ReconciliationDispatchRowTemplateProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Grid layout shared by the dispatch header row and every line row, so their columns align.
 * Cells place themselves via `gridArea` (consignment | item | date | qty | carrier | tracking | source).
 */
export const ReconciliationDispatchRowTemplate = (
  props: ReconciliationDispatchRowTemplateProps,
) => {
  const theme = useTheme();
  return (
    <Box
      sx={[
        {
          alignItems: "center",
          display: "grid",
          columnGap: theme.spacing(2),
          gridTemplateAreas: "'consignment item date qty carrier tracking source'",
          gridTemplateColumns: "150px 160px 110px 80px 150px 200px 1fr",
          px: 2,
          py: 0.75,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {props.children}
    </Box>
  );
};
